import React, { useEffect, useState } from 'react'
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment';
import FormFallingRisks from '../../containers/Admissions/AddAdmission/components/FormFallingRisks';

const EditFallingRisks = ({ caidasProps, idAdmision }) => {
    const [edit_fallingRisk, setEdit_fallingRisk] = useState(false);
    const [id_admision, setId_admision] = useState(0);
    const [disableFormFalling, setDisableFormFalling] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ title: '', color: '', message: '' });
    const [caidas, setCaidas] = useState({
        caida_previa: '',
        medicamentos: '',
        def_sensoriales: '',
        estado_mental: '',
        deambulacion: '',
        valor: 0,
        riesgo: '',
        fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
    })

    useEffect(() => {
        if (caidasProps !== undefined && caidasProps !== null) {
            setCaidas(caidasProps);
        }
        if (idAdmision !== undefined && idAdmision !== null) {
            setId_admision(idAdmision);
        }
    }, [])


    const updateFallingRisk = async () => {
        let data = {
            id_admision: id_admision,
            caidas: caidas
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/actualizar-riesgo-caida', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                setOpenAlert(true);
                setModalAlert({ title: "Riesgo de Caida", message: "Riesgo de Caida actualizada con éxito", color: "success" })
                setEdit_fallingRisk(false);
                setDisableFormFalling(true);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0.5em 0.5em' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0.5em 0.5em' }}>
                    <div>
                        <Tooltip title="Editar Riesgo de Caida">
                            <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: '#55e5bb', width: '1.2em', height: '1.2em' }}
                                onClick={() => {
                                    setEdit_fallingRisk(!edit_fallingRisk);
                                    setDisableFormFalling(false);
                                }}
                            >
                                <EditOutlinedIcon style={{ color: '#153365' }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div>
                        <p style={{ color: '#153365', padding: '0em 0.25em' }}>Riesgo de Caida:</p>
                        <p style={{ padding: '0em 0.25em', color: '#1086e0', margin: '0em' }}>{caidas.riesgo}</p>
                    </div>
                </div>
                {
                    edit_fallingRisk ?
                        <div>
                            <FormFallingRisks
                                caidas={caidas}
                                setCaidas={setCaidas}
                                updateFallingRisk={updateFallingRisk}
                                id_admision={id_admision}
                                disableFormFalling={disableFormFalling}
                                setDisableFormFalling={setDisableFormFalling}
                                edit_fallingRisk={edit_fallingRisk}
                                setEdit_fallingRisk={setEdit_fallingRisk} />
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

export default EditFallingRisks